import {FC} from 'react';
import {Currency} from 'types';
import {toCurrency} from 'utils/number';

export type CurrencyValueProps = {
    className?: string;
    currency: Currency;
    value: bigint | number;
};

const CurrencyValue: FC<CurrencyValueProps> = ({
    className,
    currency,
    value,
}) => <div className={className}>{toCurrency({currency, value})}</div>;

export default CurrencyValue;
